import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStairsUpinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M60 60H4",
				fill: "#FFE0E0",
				opacity: .654
			}),
			/* @__PURE__ */ _jsx("path", { d: "M0 0h64v64H0z" }),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "square",
				d: "M5 59V47h13V35h14V23h13V11h14"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21 13L11 23",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "square",
				strokeLinejoin: "round",
				d: "M13 13h8v8"
			})
		]
	})
});
export default SvgStairsUpinline;
